import { useState, useEffect } from "react";
import { useGetAllDrawerDataQuery } from "src/services/DrawerService";

const useDrawer = () => {
    const [drawer, setDrawer] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllDrawerDataQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setDrawer(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { drawer, isDataLoading };
};

export default useDrawer;
